export class BdAdminPermissionsStore {
  constructor(private readonly _baseUrl: string) {}

  public base(): string {
    return this._baseUrl;
  }

  public findAllPermissions(): string {
    return `${this.base()}/admin/permissions/`;
  }
}
